import { httpCall } from "../untils/NetHelper";
import { GetHeaders } from "../untils/msHelper";
import Endpoints from "../untils/urlConstants";

export function GetCSRFetch(req) {
    console.log("ENV type: " + process.env.NODE_ENV);
    // const url = (process.env.NODE_ENV === "development" ? '' : "https://mcp-web-hk.uat.ocbc.com")
    const url = (process.env.NODE_ENV === "development" ? '/digital/api/hk/' : Endpoints.getEndpoints().MSBaseURL)
        + "channel-service-request/v1/public/CSR/fetch/" + req;

    let jsonData = JSON.stringify({});
    return httpCall({
        url: url,
        method: "GET",
        data: jsonData,
        headers: GetHeaders()
    });
}

// export function GetCSRRegister(req) {
//     const url = (process.env.NODE_ENV === "development" ? '' : Endpoints.getEndpoints().MSBaseURL)
//         + "/api1/digital/api/channel-service-request-hk/v1/internal/CSR/register";

//     let header = GetHeaders('channel-service-request');
//     debugger;
//     let jsonData = JSON.stringify(req);
//     return httpCall({
//         url: url,
//         headers: header,
//         method: "POST",
//         data: jsonData,
//     });
// }
